import { VerbitLogo } from '@verbit-ai/icons-library'

import { Palette } from './types'

export const paletteDark: Palette = {
    global: {
        focusIndicatorColor: '#40E0D0',
        iconColor: '#ffffff',
    },
    header: {
        logo: <VerbitLogo theme="dark" />,
        titleColor: '#ffffff',
        panelBackgroundColor: '#020219',
        panelFilter: 'none',
        panelBorder: 'transparent transparent #757584',
        linkColor: '#ffffff',
        dropdownTextColor: '#ffffff',
        dropdownIconColor: '#ffffff',
        dropdownBgColor: '#4E4E5F',
        dropdownBorderColor: 'transparent',
    },
    transcript: {
        toolbarOuterBackground: '#020219',
        toolbarInnerBackground: 'linear-gradient(180deg, #070707 0%, rgba(0, 0, 0, 0.00) 100%)',
        speakerColors: ['#CCCCD1', '#CCCCD1', '#CCCCD1', '#CCCCD1', '#CCCCD1', '#CCCCD1'],
        timestampColors: ['#E4E4E5', '#E4E4E5', '#E4E4E5', '#E4E4E5', '#E4E4E5', '#E4E4E5'],
        appBackgroundColors: [
            { colorValue: '#020219', colorTitle: 'Black' },
            { colorValue: '', colorTitle: '' },
        ],
        textColors: [
            { colorValue: '#ffffff', colorTitle: 'White' },
            { colorValue: '#F4D7FA', colorTitle: 'Pink' },
            { colorValue: '#4BFBE4', colorTitle: 'Teal' },
            { colorValue: '#E1F2D5', colorTitle: 'Sage' },
            { colorValue: '#FFCC69', colorTitle: 'Orange' },
            { colorValue: '#EFFF76', colorTitle: 'Lime' },
        ],
        textBackgroundColors: [
            { colorValue: '#020219', colorTitle: 'Black' },
            { colorValue: '#046492', colorTitle: 'Blue' },
            { colorValue: '#697A7A', colorTitle: 'Green' },
            { colorValue: '#A52F18', colorTitle: 'Brown' },
            { colorValue: '#4044C6', colorTitle: 'Purple' },
            { colorValue: '#C02469', colorTitle: 'Pink' },
        ],
        loaderColor: '#40E0D0',
        searchResultHighlight: '#757584',
        activeParagraphOutline: '#4E4E5F',
    },
    toolbar: {
        btnColor: '#ffffff',
        btnHoverColor: '#40E0D0',
        mobilePanelBorder: '#CCCCD1',
        mobilePanelIconColor: '#fff',
        extrasIconColor: '#fff',
        extrasTextColor: '#fff',
        extrasBackground: '#30404d',
        sessionDetailsColor: '#fff',
    },
    verbitButton: {
        primaryBackgroundColor: '#40E0D0',
        primaryHoverBgColor: '#2196F3',
        primaryBorderColor: '#40E0D0',
        primaryHoverBorderColor: '#40E0D0',
        primaryTextColor: '#030D69',
        secondaryBackgroundColor: 'transparent',
        secondaryHoverBgColor: 'transparent',
        secondaryBorderColor: '#40E0D0',
        secondaryHoverBorderColor: '#40E0D0',
        secondaryTextColor: '#40E0D0',
    },
    verbitModal: {
        backgroundColor: '#2d3748',
        titleColor: '#fff',
        subtitleColor: '#ccc',
        textColor: '#fff',
        closeIconColor: '#fff',
        closeHoverBgColor: '#bfbfbf30',
    },
    verbitCheckbox: {
        labelColor: '#fff',
        boxBorderColor: '#fff',
        checkedBoxBgColor: '#40E0D0',
        checkedBoxIconColor: '#030D69',
    },
    verbitSelect: {
        borderColor: '#fff',
        valueColor: '#fff',
        indicatorColor: '#fff',
        focusedShadow: '0 0 0 1px #40E0D0',
        listBgColor: '#2f343c',
        listShadow: '0 0 0 1px hsl(215, 3%, 38%)',
        optionColor: '#fff',
        checkIconColor: '#40E0D0',
        optionFocusedBgColor: '#293743',
    },
    search: {
        outerBorderColor: '#30404d',
        innerBorderColor: '#757584',
        inputBgColor: '#020219',
        textColor: '#ffffff',
        placeholderColor: '#ffffff',
        clearButtonColor: '#ffffff',
        navButtonColor: '#ffffff',
        resultsColor: '#ffffff',
    },
    fontSizeControl: {
        backgroundColor: '#30404d',
        iconColor: '#ffffff',
        textColor: '#ffffff',
        optionHoverColor: '#293743',
        delimiterColor: '#e2e8f0',
    },
    downloadControl: {
        backgroundColor: '#30404d',
        textColor: '#ffffff',
        optionHoverColor: '#293743',
    },
    themeToggle: {
        backgroundColor: '#30404d',
        iconColor: '#40E0D0',
        textColor: '#ffffff',
        titleColor: '#40E0D0',
        colorOptionsBgColor: '#020219',
        fontOptionsBorderColor: '#757584',
        defaultColorIndicatorStroke: '#757584',
        colorIndicatorActiveColor: '#ffffff',
        mobileColorIndicatorBorderColor: '#B3B3BA',
        mobileButtonBorderColor: '#CCCCD1',
        mobileActiveColor: '#40E0D0',
    },
    languageSelect: {
        desktopTextColor: '#ffffff',
        desktopBgColor: '#30404d',
        mobileTextColor: '#FFFFFF',
        iconColor: '#40E0D0',
        separatorColor: '#E4E4E5',
        mobileTitleColor: '#40E0D0',
        mobileBgColor: '#30404d',
    },
    toast: {
        backgroundColor: '#020219',
        borderColor: '#757584',
        textColor: '#ffffff',
        successTextColor: '#40E0D0',
        actionColor: '#40E0D0',
        successIconColor: '#40E0D0',
        infoIconColor: '#ffffff',
        closeIconColor: '#ffffff',
        shadow: '0px 4px 14px 0px rgba(255, 255, 255, 0.20)',
    },
    scrollDownButton: {
        borderColor: '#757584',
        shadow: '0px 2px 10px 4px rgb(255 255 255 / 10%)',
        attentionPulseColor: '#ffffff',
        autoscrollOff: {
            iconColor: '#ffffff',
            backgroundColor: '#252536',
        },
        autoscrollOn: {
            iconColor: '#06060e',
            backgroundColor: '#40E0D0',
        },
    },
    inconsistencyIndicator: {
        color: '#40E0D0',
        hoverBackgroundColor: '#40E0D029',
        selectedContentColor: '#020219',
        paragraphHoverBackgroundColor: '#FFFFFF0F',
    },
    routingError: {
        backgroundColor: '#020219',
        textColor: '#ffffff',
        linkColor: '#40E0D0',
    },
    editor: {
        activeMediaTimingHighlight: '#458BD9CC',
    },
    verbitSwitch: {
        default: '#ffffff',
        trackActiveBgColor: '#139346',
        trackInactiveBgColor: '#747483',
    },
    quickActionMenu: {
        backgroundColor: '#2A3E64',
        dividerColor: 'rgba(255, 255, 255, 0.20)',
        buttonColor: '#FFFFFF',
        buttonHoverBgColor: '#0D2240',
        buttonDisabledColor: '#7f8ba2',
    },
}
